import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	FormGroup,
	FormControl,
	Dropdown,
	Button,
	ButtonGroup,
	Nav,
} from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import { TabletOrDesktop, Mobile } from 'utils/responsive';
import {
	FiPlus,
	FiSearch,
	FiMoreHorizontal,
	FiDownload,
	FiList,
	FiGrid,
	FiUpload,
	FiCheck,
	FiX,
	FiUsers,
	FiCheckSquare,
	FiClock,
	FiLock,
} from 'react-icons/fi';
import { MdOutlineMarkEmailUnread } from 'react-icons/md';
import Moment from 'react-moment';
import { toastr } from 'react-redux-toastr';
import { errorFormating, getAppName, formatNumber } from 'utils/utils';
import Avatar from 'components/Avatar';
import * as groupsActions from 'actions/groupsActions';
import { showModal, hideModal, updateModalLoading } from 'actions/modalActions';
import { employeesService, appService, timesService } from 'services';
import Loading from 'components/Loading';
import { withTranslation } from 'react-i18next';
import EmployeeListItemHeader from 'components/Employees/EmployeeListItemHeader';
import Layout from 'components/Layout';
import Modal from 'components/Modal';
import EmployeeEditModal from 'components/Employees/EmployeeEditModal';
import EmployeeEditDrawer from 'components/Employees/EmployeeEditDrawer';
import EmployeeInvitationLinkModal from 'components/Employees/EmployeeInvitationLinkModal';
import HelpBanner from 'components/HelpBanner';
import KpiCard from 'components/KpiCard';
import AttendanceStatusCard from 'components/AttendanceSupervisor/AttendanceStatusCard';
import DataTable from 'components/DataTable';
import PendingEmployeeConfigurations from 'components/Employees/PendingEmployeeConfigurations';

/** Tamaño de página al cargar más filas (mismo orden que fichajes / supervisor). */
const EMPLOYEES_PAGE_SIZE = 40;
const EMPLOYEES_INFINITE_SCROLL_TARGET_ID = 'employees-infinite-scroll-target';

function compareEmployeeValues(a, b) {
	if (a == null && b == null) return 0;
	if (a == null) return 1;
	if (b == null) return -1;
	if (typeof a === 'number' && typeof b === 'number') return a - b;
	return String(a).localeCompare(String(b), 'es', {
		numeric: true,
		sensitivity: 'base',
	});
}

function employeeSortValue(key, employee) {
	switch (key) {
		case 'name':
			return [employee.name, employee.surname].filter(Boolean).join(' ') || null;
		case 'position':
			return employee.position || null;
		case 'contact':
			return employee.email || employee.phone || null;
		case 'start_day':
			return employee.start_day || null;
		case 'status':
			if (!employee.enabled) return 0;
			if (employee.with_access && !employee.last_login) return 1;
			return 2;
		case 'plain_access':
			return employee.with_access ? 1 : 0;
		default:
			return null;
	}
}

function sortEmployeeRows(rows, sort) {
	if (!sort || sort.key === 'name') return rows;
	const direction = sort.direction === 'desc' ? -1 : 1;
	return [...rows].sort((a, b) => {
		const va = employeeSortValue(sort.key, a);
		const vb = employeeSortValue(sort.key, b);
		// El vacío también cambia de extremo al invertir la columna.
		return direction * compareEmployeeValues(va, vb);
	});
}

class Employees extends Component {
	constructor(props) {
		super(props);
		//console.log(props);

		this.state = {
			loading: false,
			searchEmployee: '',
			filterGroupId: '',
			filterStatus: 'activos', // Default: activos
			employeePageTab: 'list',
			is_list_view: true,
			employeeCounts: null,
			timeRegistrationsSummary: null,
			accumulatedEmployees: [],
			listPage: 0,
			hasMore: true,
			employeesLoading: false,
			employeesLoadingMore: false,
			listLoadError: null,
			employeeSort: null,
			pendingListVersion: 0,
			// Drawer de empleado (se abre sobre la página sin navegar)
			employeeDrawerOpen: false,
			employeeDrawerTarget: null,
		};

		// Variables para el debounce
		this.searchTimeout = null;
		this.currentSearchRequest = null;

		this.closeModal = this.closeModal.bind(this);
		this.openDeleteEmployeeModal = this.openDeleteEmployeeModal.bind(this);
		this.openNewEmployeeModal = this.openNewEmployeeModal.bind(this);
		this.openInvitationLinkModal = this.openInvitationLinkModal.bind(this);
		this.loadEmployeeList = this.loadEmployeeList.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.search !== this.props.location.search) {
			this.syncStateFromUrl();
		}
	}

	syncStateFromUrl = () => {
		const params = new URLSearchParams(this.props.location.search);
		const searchEmployee = params.get('q') || '';
		const filterGroupId = params.get('group_id') || '';
		// Default to 'activos' if not in URL, but if it is in URL, use it
		const filterStatus = params.get('status') || 'activos';
		const employeePageTab = params.get('tab') === 'pending' ? 'pending' : 'list';

		this.setState(
			{
				searchEmployee,
				filterGroupId,
				filterStatus,
				employeePageTab,
			},
			() => {
				if (employeePageTab === 'list') this.loadEmployeeList(false);
			}
		);
	};

	handleEmployeePageTab = (employeePageTab) => {
		const params = new URLSearchParams(this.props.location.search);
		if (employeePageTab === 'pending') params.set('tab', 'pending');
		else params.delete('tab');
		this.props.history.push({
			pathname: this.props.location.pathname,
			search: params.toString(),
		});
	};

	updateUrl = (updates) => {
		const currentParams = new URLSearchParams(this.props.location.search);
		const { searchEmployee, filterGroupId, filterStatus } = this.state;

		// Merge current state with updates
		const newState = {
			q: searchEmployee,
			group_id: filterGroupId,
			status: filterStatus,
			...updates,
		};

		// Update params
		if (newState.q) currentParams.set('q', newState.q);
		else currentParams.delete('q');

		if (newState.group_id) currentParams.set('group_id', newState.group_id);
		else currentParams.delete('group_id');

		if (newState.status && newState.status !== 'activos') currentParams.set('status', newState.status);
		else if (newState.status === 'activos') currentParams.delete('status'); // Cleaner URL for default

		this.props.history.push({
			pathname: this.props.location.pathname,
			search: currentParams.toString(),
		});
	};

	handleChangeSearch = (event) => {
		const targetId = event.target.id;
		const value = event.target.value;

		this.setState({
			[targetId]: value,
		});

		if (targetId === 'searchEmployee') {
			this.debouncedUpdateUrl(value);
		} else {
			// Map state keys to URL param keys
			const paramKey =
				targetId === 'filterGroupId'
					? 'group_id'
					: targetId === 'filterStatus'
						? 'status'
						: targetId;
			this.updateUrl({ [paramKey]: value });
		}
	};

	// Método para implementar debounce en la actualización de la URL
	debouncedUpdateUrl = (searchTerm) => {
		// Limpiar el timeout anterior
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}

		// Solo buscar si hay al menos 3 caracteres o está vacío
		if (searchTerm.length >= 3 || searchTerm.length === 0) {
			this.searchTimeout = setTimeout(() => {
				this.updateUrl({ q: searchTerm });
			}, 500); // 500ms de delay
		}
	};

	buildEmployeeListParams(page) {
		const params = {
			q: this.state.searchEmployee,
			group_id: this.state.filterGroupId,
			variant: 'select',
			page,
			page_size: EMPLOYEES_PAGE_SIZE,
		};

		switch (this.state.filterStatus) {
			case 'activos':
				params.enabled = true;
				break;
			case 'inactivos':
				params.enabled = false;
				break;
			case 'acceso_plain':
				params.with_access = true;
				break;
			case 'todos':
			default:
				break;
		}

		const sort = this.state.employeeSort;
		if (sort && sort.key === 'name') {
			params.sort = sort.direction === 'desc' ? '-name,-surname' : '+name,+surname';
		}

		return params;
	}

	refreshPendingConfigurations = () => {
		this.setState((prev) => ({
			pendingListVersion: prev.pendingListVersion + 1,
		}));
	};

	handleEmployeeSort = (sort) => {
		this.setState({ employeeSort: sort }, () => {
			if (sort.key === 'name') this.loadEmployeeList(false);
		});
	};

	async loadEmployeeList(append) {
		if (append) {
			if (
				!this.state.hasMore ||
				this.state.employeesLoadingMore ||
				this.state.employeesLoading
			) {
				return;
			}
		} else if (this.currentSearchRequest) {
			this.currentSearchRequest.abort();
		}

		const pageToFetch = append ? this.state.listPage + 1 : 0;

		if (!append) {
			this.setState({
				accumulatedEmployees: [],
				listPage: 0,
				hasMore: true,
				employeesLoading: true,
				listLoadError: null,
			});
		} else {
			this.setState({ employeesLoadingMore: true });
		}

		const controller = new AbortController();
		if (!append) {
			this.currentSearchRequest = controller;
		}

		try {
			const res = await employeesService.getAll(
				this.buildEmployeeListParams(pageToFetch),
				controller.signal
			);

			if (!append) {
				this.currentSearchRequest = null;
			}

			if (!res.ok) {
				const msg =
					res.errors?.[0]?.description ||
					this.props.t('employees.loadError');
				throw new Error(msg);
			}

			const newRows = Array.isArray(res.data) ? res.data : [];
			const totalItems = res.pagination?.total_items ?? 0;

			const accumulated = append
				? [...this.state.accumulatedEmployees, ...newRows]
				: newRows;

			let hasMore = false;
			if (newRows.length > 0) {
				if (newRows.length < EMPLOYEES_PAGE_SIZE) {
					hasMore = false;
				} else if (totalItems > 0) {
					hasMore = accumulated.length < totalItems;
				} else {
					hasMore = true;
				}
			}

			this.setState({
				accumulatedEmployees: accumulated,
				listPage: pageToFetch,
				hasMore,
				employeesLoading: false,
				employeesLoadingMore: false,
				listLoadError: null,
			});
		} catch (error) {
			if (error.name === 'AbortError') {
				return;
			}
			console.error('Error al obtener empleados:', error);
			if (!append) {
				this.currentSearchRequest = null;
				this.setState({
					employeesLoading: false,
					employeesLoadingMore: false,
					listLoadError:
						error.message ||
						this.props.t('employees.loadError'),
				});
			} else {
				this.setState({
					employeesLoading: false,
					employeesLoadingMore: false,
					hasMore: false,
				});
			}
		}
	}

	fetchMoreEmployees = () => {
		this.loadEmployeeList(true);
	};

	async getGroups() {
		this.setState({
			loading: true,
		});
		await this.props.getAllGroups();
		this.setState({
			loading: false,
		});
	}

	// open new employee modal
	openNewEmployeeModal() {
		const refreshLists = () => {
			this.loadEmployeeList(false);
			this.getEmployeeCounts();
			this.refreshPendingConfigurations();
		};
		const closeAndRefresh = () => {
			this.closeModal();
			this.refreshPendingConfigurations();
		};
		const setModalTitle = (newTitle) => {
			// console.log("setModalTitle", newTitle);
			this.props.showModal(
				{
					open: true,
					title: newTitle, // Se actualiza dinámicamente
					style: { width: '500px' },
					content: (
						<EmployeeEditModal
							handleClose={closeAndRefresh}
							setModalTitle={setModalTitle} // Se pasa al componente del modal
							reloadEmployeeData={refreshLists}
						/>
					),
					closeModal: closeAndRefresh,
				},
				'edit'
			);
		};

		// Configura el título inicial
		setModalTitle(this.props.t('employees.newEmployee'));
	}

	closeModal() {
		this.props.hideModal();
	}

	openDeleteEmployeeModal(idEmployee) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('employees.deleteEmployee'),
				style: { width: '400px' },
				message: this.props.t('employees.deleteConfirm'),
				deleteAction: () => this.confirmDelete(idEmployee),
				closeModal: this.closeModal,
			},
			'delete'
		);
	}

	openAlertModal(title, message) {
		this.props.showModal(
			{
				open: true,
				title: title,
				style: { width: '400px' },
				message: message,
				closeModal: this.closeModal,
			},
			'alert'
		);
	}

	openInvitationLinkModal(employee) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('employees.invitationLink'),
				style: { width: '500px' },
				content: (
					<EmployeeInvitationLinkModal
						closeModal={this.closeModal}
						employee={employee}
					/>
				),
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	confirmDelete = async (idEmployee) => {
		const response = await employeesService.remove(idEmployee);
		this.closeModal();

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(this.props.t('employees.deleteError'), textError.id);
		} else {
			this.loadEmployeeList(false);
		}
	};

	async getEmployeeCounts() {
		try {
			const [activeRes, pendingRes] = await Promise.all([
				employeesService.getAll({ enabled: true, variant: 'select', page_size: 1 }),
				employeesService.getAll({
					enabled: true,
					with_access: true,
					last_login: false,
					variant: 'select',
					page_size: 1,
				}),
			]);

			const pendingCount = pendingRes?.pagination?.total_items ?? 0;

			this.setState({
				employeeCounts: {
					active: activeRes?.pagination?.total_items ?? 0,
					pending: pendingCount,
				},
			});
		} catch (error) {
			if (error.name !== 'AbortError') {
				console.error('Error al cargar contadores de empleados:', error);
			}
			this.setState({ employeeCounts: null });
		}
	}

	componentDidMount() {
		this.syncStateFromUrl();
		this.getGroups();
		this.getEmployeeCounts();

		// Cargar resumen de fichajes de hoy (activos/pausa/ausentes) para la plantilla
		timesService.getSummaryToday()
			.then((res) => {
				this.setState({ timeRegistrationsSummary: res });
			})
			.catch(() => {
				this.setState({ timeRegistrationsSummary: null });
			});
	}

	componentWillUnmount() {
		// Limpiar timeout de búsqueda
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}

		// Cancelar petición pendiente
		if (this.currentSearchRequest) {
			this.currentSearchRequest.abort();
		}
	}

	// Employee view list / grid
	handleChangeView = (is_list_view) => {
		this.setState({
			is_list_view,
		});
	};

	openExportEmployeesModal(token) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('employees.exportTitle'),
				style: { width: '400px' },
				confirmText: this.props.t('employees.download'),
				loadingText: this.props.t('employees.downloading'),
				message:
					this.props.t('employees.exportConfirm'),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, 'empleados.xlsx');
				},
			},
			'confirm'
		);
	}

	openSendInactiveInvitationsModal = () => {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('employees.sendInactiveInvitationsTitle'),
				style: { width: '400px' },
				confirmText: this.props.t('employees.sendInvitation'),
				loadingText: this.props.t('employees.sendingInvitation'),
				message:
					this.props.t('employees.sendInactiveInvitationsMessage'),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.handleSendInactiveInvitations();
				},
			},
			'confirm'
		);
	};

	handleSendInactiveInvitations = async () => {
		this.props.updateModalLoading(true);

		try {
			const response = await employeesService.sendInvitationToInactiveEmployees();

			if (response.ok) {
				toastr.success(
					this.props.t('common.success'),
					this.props.t('employees.sendInactiveInvitationsSuccess')
				);
			} else {
				const textError = errorFormating(response);
				toastr.error(
					'Error',
					textError?.id ||
						this.props.t('employees.sendInactiveInvitationsError')
				);
			}
		} catch (error) {
			toastr.error(
				'Error',
				this.props.t('employees.sendInactiveInvitationsError')
			);
		} finally {
			this.props.updateModalLoading(false);
			this.closeModal();
		}
	};

	async handleExportEmployees() {
		const { searchEmployee, filterGroupId, filterStatus } = this.state;

		// Construir parámetros según el estado seleccionado
		const params = {
			group_id: filterGroupId,
			q: searchEmployee,
		};

		// Agregar parámetros según el filtro de estado
		switch (filterStatus) {
			case 'activos':
				params.enabled = true;
				break;
			case 'inactivos':
				params.enabled = false;
				break;
			case 'acceso_plain':
				params.with_access = true;
				break;
			case 'todos':
			default:
				// No agregar parámetros para exportar todos
				break;
		}

		const token = await employeesService.exportEmployees(params);

		if (token.ok) {
			this.openExportEmployeesModal(token.access_token);
		} else {
			this.openAlertModal(
				this.props.t('employees.exportError'),
				this.props.t('employees.exportErrorDetail')
			);
		}
	}

	async downloadExport(token, filename) {
		const response = await appService.getExported(token);
		var url = window.URL.createObjectURL(response);
		var a = document.createElement('a');
		document.body.appendChild(a);
		a.href = url;
		a.download = filename;
		a.click();

		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	getContent = () => {
		const {
			accumulatedEmployees,
			employeesLoading,
			employeesLoadingMore,
			hasMore,
			listLoadError,
		} = this.state;

		if (employeesLoading && accumulatedEmployees.length === 0) {
			return <Loading />;
		}

		if (listLoadError) {
			return listLoadError;
		}

		if (accumulatedEmployees.length === 0 && !employeesLoading) {
			return this.getEmptyRow();
		}

		const infiniteCommon = {
			dataLength: accumulatedEmployees.length,
			next: this.fetchMoreEmployees,
			hasMore,
			loader: employeesLoadingMore ? (
				<div className="text-center py-2 employees-infinite-loader">
					{this.props.t('employees.loading')}
				</div>
			) : null,
			endMessage:
				accumulatedEmployees.length > 0 && !hasMore ? (
					<p className="no-more-results text-center employees-infinite-end">
						{this.props.t('employees.noMore')}
					</p>
				) : null,
			scrollThreshold: 0.9,
		};

		if (this.state.is_list_view) {
			return (
				<>
					<Mobile>
						<InfiniteScroll {...infiniteCommon}>
							<table className="table table-employees table-mobile">
								<tbody>{this.getTableRowsMobile()}</tbody>
							</table>
						</InfiniteScroll>
					</Mobile>
					<TabletOrDesktop>
						<DataTable
							className="employees-datatable-scroll"
							scrollContainerId={EMPLOYEES_INFINITE_SCROLL_TARGET_ID}
							scrollContainerClassName="table-responsive employees-infinite-scroll-wrap"
							tableClassName="table-employees table-desktop table-hover"
							tableStyle={{ backgroundColor: '#ffffff' }}
							columns={this.getEmployeeDesktopColumns()}
							rows={sortEmployeeRows(accumulatedEmployees, this.state.employeeSort)}
							rowKey={(row) => row.id}
							sortState={this.state.employeeSort}
							onSortChange={this.handleEmployeeSort}
							emptyMessage={
								employeesLoadingMore ? this.props.t('employees.loading') : this.props.t('employees.noResults')
							}
							actionsColumn={{
								render: (employee) => this.getActions(employee),
								className: 'td-actions',
							}}
							infiniteScroll={{
								...infiniteCommon,
								scrollableTarget: EMPLOYEES_INFINITE_SCROLL_TARGET_ID,
							}}
						/>
					</TabletOrDesktop>
				</>
			);
		}

		return (
			<InfiniteScroll {...infiniteCommon}>
				<div className="row grid-employees">{this.getGridRows()}</div>
			</InfiniteScroll>
		);
	};

	getEmptyRow = () => {
		return <p>{this.props.t('employees.noResults')}</p>;
	};

	openViewEmployeePage(employee) {
		this.setState({
			employeeDrawerOpen: true,
			employeeDrawerTarget: employee,
		});
	}

	closeEmployeeDrawer = () => {
		this.setState({ employeeDrawerOpen: false });
	};

	getActions = (employee) => {
		// Verificar si el empleado está PENDIENTE (enabled && with_access && !last_login)
		const isPending = employee.enabled && employee.with_access && !employee.last_login;

		return (
			<Dropdown>
				<Dropdown.Toggle variant="action">
					<FiMoreHorizontal />
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item
						as="button"
						onClick={() => this.openViewEmployeePage(employee)}
					>
						{this.props.t('employees.viewProfile')}
					</Dropdown.Item>
					{isPending && (
						<Dropdown.Item
							as="button"
							onClick={() => this.openInvitationLinkModal(employee)}
						>
							{this.props.t('employees.invitationLink')}
						</Dropdown.Item>
					)}
					{!this.state.isMe && (
						<Dropdown.Item
							as="button"
							onClick={() => this.openDeleteEmployeeModal(employee.id)}
						>
							{this.props.t("employees.deleteAction")}
						</Dropdown.Item>
					)}
				</Dropdown.Menu>
			</Dropdown>
		);
	};

	getEmployeeDesktopColumns = () => {
		const appName = getAppName();
		return [
			{
				key: 'name',
				header: this.props.t('employees.colName'),
				className: 'td-name',
				render: (employee) => (
					<div className="td-name-content">
						<Link to={`/employees/${employee.id}`}>
							<Avatar
								userId={employee.id}
								className="avatar-sm"
								alt={employee.name}
							/>
						</Link>
						<div className="employee-info">
							<Link className="employee-name" to={`/employees/${employee.id}`}>
								{employee.name} {employee.surname}
							</Link>
							{employee.code && (
								<span className="employee-code">{employee.code}</span>
							)}
						</div>
					</div>
				),
			},
			{
				key: 'position',
				header: this.props.t('employees.colPosition'),
				render: (employee) => employee.position,
			},
			{
				key: 'contact',
				header: this.props.t('employees.colContact'),
				render: (employee) => (
					<>
						<span className="employee-email">{employee.email}</span>
						<span className="employee-phone">{employee.phone}</span>
					</>
				),
			},
			{
				key: 'start_day',
				header: this.props.t('employees.colStartDay'),
				render: (employee) => (
					<Moment className="tag-dia" format="DD/MM/YYYY">
						{employee.start_day}
					</Moment>
				),
			},
			{
				key: 'status',
				header: this.props.t('employees.colActive'),
				align: 'center',
				render: (employee) =>
					employee.enabled && employee.with_access && !employee.last_login ? (
						<span
							title={this.props.t("employees.statusPendingFull")}
							className="estado estado-pendiente"
						>
							{this.props.t("employees.statusPending")}
						</span>
					) : !employee.enabled ? (
						<span title={this.props.t("employees.statusInactive")} className="estado estado-no">
							{this.props.t("employees.statusInactive")}
						</span>
					) : (
								<span title={this.props.t("employees.statusActive")} className="estado estado-si">
									{this.props.t("employees.statusActive")}
								</span>
							),
			},
			{
				key: 'plain_access',
				header: this.props.t('employees.colAccess', { appName }),
				headerTitle: this.props.t('employees.colAccess', { appName }),
				align: 'center',
				className: 'td-access text-center',
				render: (employee) =>
					employee.with_access ? (
						<FiCheck className="icon-access icon-yes" />
					) : (
							<FiX className="icon-access icon-no" />
						),
			},
		];
	};

	getTableRowsMobile = () =>
		this.state.accumulatedEmployees.map((employee) => (
			<tr key={employee.id}>
				<td className="td-name">
					<div className="td-name-content">
						<Link to={`/employees/${employee.id}`}>
							<Avatar
								userId={employee.id}
								className="avatar-sm"
								alt={employee.name}
							/>
						</Link>
						<div className="employee-info">
							<Link className="employee-name" to={`/employees/${employee.id}`}>
								{employee.name} {employee.surname}
							</Link>
							{employee.code && (
								<span className="employee-code">{employee.code}</span>
							)}
							{employee.position && (
								<span className="employee-position">{employee.position}</span>
							)}
						</div>
					</div>
				</td>
				<td>
					{employee.enabled && employee.with_access && !employee.last_login ? (
						<span
							title={this.props.t("employees.statusPendingFull")}
							className="estado estado-no"
						>
							{this.props.t("employees.statusPendingFull")}
						</span>
					) : !employee.enabled ? (
						<span title={this.props.t("employees.statusInactive")} className="estado estado-no">
							{this.props.t("employees.statusInactive")}
						</span>
					) : (
								<span title={this.props.t("employees.statusActive")} className="estado estado-si">
									{this.props.t("employees.statusActive")}
								</span>
							)}
				</td>
				<td className="td-actions">{this.getActions(employee)}</td>
			</tr>
		));

	getGridRows = () =>
		this.state.accumulatedEmployees.map((employee) => (
			<div className="col-sm-6 col-lg-4 col-xl-3" key={employee.id}>
				<article className="card" key={employee.id}>
					<EmployeeListItemHeader employee={employee} />

					<div className="card-content">
						<a className="email" href="mailto:{ employee.email }">
							{employee.email}
						</a>

						{employee.code && (
							<div className="form-group no-form">
								<label>{this.props.t('employees.employeeCode')}</label>
								<span>{employee.code}</span>
							</div>
						)}

						{employee.phone && (
							<div className="form-group no-form">
								<label>{this.props.t('employee.phone')}</label>
								<span>{employee.phone}</span>
							</div>
						)}

						<div className="form-group no-form">
							<label>{this.props.t('employee.contractDate')}</label>
							<Moment className="tag-dia" format="D MMMM YYYY">
								{employee.start_day}
							</Moment>
						</div>

						{employee.end_day ? (
							<div className="form-group no-form">
								<label>{this.props.t('employee.endDay')}</label>
								<Moment className="tag-dia" format="D MMMM YYYY">
									{employee.end_day}
								</Moment>
							</div>
						) : (
								<div className="form-group no-form">
									<label>{this.props.t('employees.seniority')}</label>
									<p className="seniority">
										<span className="seniority-time">
											{employee.seniority.years}
										</span>
										{employee.seniority.years === 1 ? this.props.t('employees.seniorityYear') : this.props.t('employees.seniorityYears')}
										<span className="seniority-time">
											{employee.seniority.months}
										</span>
										{employee.seniority.months === 1 ? this.props.t('employees.seniorityMonth') : this.props.t('employees.seniorityMonths')}
									&nbsp;y{' '}
										<span className="seniority-time">
											{employee.seniority.days}
										</span>
										{employee.seniority.days === 1 ? this.props.t('employees.seniorityDay') : this.props.t('employees.seniorityDays')}
									</p>
								</div>
							)}

						{employee.enabled &&
							employee.with_access &&
							!employee.last_login ? (
								<span
									title={this.props.t("employees.statusPendingFull")}
									className="estado estado-no"
								>
									{this.props.t("employees.statusPendingFull")}
								</span>
							) : (
								!employee.enabled && (
									<span title={this.props.t("employees.statusInactive")} className="estado estado-no">
										{this.props.t("employees.statusInactive")}
									</span>
								)
							)}
					</div>
					<Link
						className="btn btn-primary btn-inline"
						to={`/employees/${employee.id}`}
					>
						{this.props.t("employees.viewProfile")}
					</Link>
				</article>
			</div>
		));

	render() {
		const { groups } = this.props;
		const { is_list_view, filterStatus, employeePageTab } = this.state;
		const appName = getAppName();

		const optionList =
			groups &&
			groups.length > 0 &&
			groups.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		return (
			<>
				<Layout className="page-employees" context="employees">
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">
								{this.props.t('employees.title')}
								{/* {(this.state.employeeCounts?.total ?? this.props.pagination?.total_items) != null && (
									<span className="title-count">({this.state.employeeCounts?.total ?? this.props.pagination?.total_items})</span>
								)} */}
							</h1>
						</div>
						<div className="mr10 hidden-md">
							<HelpBanner
								title={this.props.t('employees.helpTitle')}
								text={this.props.t('employees.helpText')}
								linkText={this.props.t('common.moreInfo')}
								linkHref="https://help.plain.ninja/es/collections/2144658-empleados-funciones-y-ubicaciones"
							/>
						</div>
						{employeePageTab === 'list' && <div className="heading-filters">
							<ButtonGroup aria-label="Employees view">
								<Button
									variant={`${is_list_view ? 'primary' : 'default'}`}
									onClick={() => this.handleChangeView(true)}
								>
									<FiList className="icon" />
								</Button>
								<Button
									variant={`${!is_list_view ? 'primary' : 'default'}`}
									onClick={() => this.handleChangeView(false)}
								>
									<FiGrid className="icon" />
								</Button>
							</ButtonGroup>
						</div>}
						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t('employees.newEmployee')}
								onClick={this.openNewEmployeeModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>

							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.props.history.push('/employees/import')}
									>
										<FiDownload className="dropdown-icon" />{this.props.t('employees.importEmployees')}
									</Dropdown.Item>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.history.push(
												'/employees/shift-patterns/import'
											)
										}
									>
										<FiDownload className='dropdown-icon' />{this.props.t('employees.importShiftPatterns')}
									</Dropdown.Item>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.history.push('/employees/functions/import')
										}
									>
										<FiDownload className='dropdown-icon' />{this.props.t('employees.importFunctions')}
									</Dropdown.Item>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.history.push('/employees/ubications/import')
										}
									>
										<FiDownload className='dropdown-icon' />{this.props.t('employees.importUbications')}
									</Dropdown.Item>
									<Dropdown.Item
										as="button"
										onClick={() => this.handleExportEmployees()}
									>
										<FiUpload className="dropdown-icon" />{this.props.t('employees.exportEmployees')}
									</Dropdown.Item>
									<Dropdown.Item
										as="button"
										onClick={this.openSendInactiveInvitationsModal}
									>
										<MdOutlineMarkEmailUnread className='dropdown-icon' />{this.props.t('employees.sendInactiveInvitationsTitle')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					<Nav
							variant="tabs"
							activeKey={employeePageTab}
							onSelect={this.handleEmployeePageTab}
							className="employees-page-tabs"
						>
							<Nav.Item>
								<Nav.Link eventKey="list">{this.props.t('pendingConfigurations.employeeList')}</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link eventKey="pending">
									{this.props.t('pendingConfigurations.tabTitle')}
									<span className="badge-new">{this.props.t('common.new')}</span>
								</Nav.Link>
							</Nav.Item>
					</Nav>

					{employeePageTab === 'pending' ? (
						<PendingEmployeeConfigurations refreshVersion={this.state.pendingListVersion} />
					) : <>
					<div className="employees-kpi-section">
						<div className="kpi-cards-container">
							<AttendanceStatusCard
								summary={this.state.timeRegistrationsSummary}
							/>
							<KpiCard
								className="kpi-card-active"
								title={this.props.t('employees.kpiActive')}
								value={
									this.state.employeeCounts?.active != null
										? formatNumber(this.state.employeeCounts.active)
										: "-"
								}
								icon={<FiCheckSquare size={18} />}
								iconColor="#10B981"
							/>
							<KpiCard
								className="kpi-card-pending"
								title={this.props.t('employees.kpiPending')}
								value={
									this.state.employeeCounts?.pending != null
										? formatNumber(this.state.employeeCounts.pending)
										: "-"
								}
								icon={<FiClock size={18} />}
								iconColor="#F59E0B"
							/>

						</div>
					</div>

					<div className="employees-filters-bar">
						<FormGroup
							className="form-group form-search"
							controlId="searchEmployee"
						>
							<FormControl
								type="text"
								placeholder={this.props.t('employees.searchPlaceholder')}
								value={this.state.searchEmployee}
								onChange={this.handleChangeSearch}
							/>
							<FiSearch />
							{this.state.searchEmployee.length > 0 &&
								this.state.searchEmployee.length < 3 && (
									<div className="search-hint">
										{this.props.t('employees.searchHint')}
									</div>
								)}
						</FormGroup>
						<FormGroup
							className="form-group form-search"
							controlId="filterStatus"
						>
							<FormControl
								as="select"
								value={filterStatus}
								onChange={this.handleChangeSearch}
							>
								<option value="todos">{this.props.t('employees.filterAll')}</option>
								<option value="activos">{this.props.t('employees.filterActive')}</option>
								<option value="inactivos">{this.props.t('employees.filterInactive')}</option>
								<option value="acceso_plain">{this.props.t('employees.filterAccess', { appName })}</option>
							</FormControl>
						</FormGroup>
						<FormGroup
							className="form-group form-search"
							controlId="filterGroupId"
						>
							<FormControl
								type="text"
								placeholder={this.props.t('employees.searchPlaceholder')}
								value={this.state.filterGroupId}
								onChange={this.handleChangeSearch}
								as="select"
							>
								<option value="">{this.props.t('employees.filterByGroup')}</option>
								{optionList}
							</FormControl>
						</FormGroup>
					</div>

					{this.getContent()}
					</>}
				</Layout>

				<Modal hideModal={this.props.hideModal} />

				<EmployeeEditDrawer
					isOpen={this.state.employeeDrawerOpen}
					onClose={this.closeEmployeeDrawer}
					employee={this.state.employeeDrawerTarget}
					employeeId={
						this.state.employeeDrawerTarget &&
						this.state.employeeDrawerTarget.id
					}
				/>
			</>
		);
	}
}

const mapStateToProps = (reducers) => ({
	...reducers.groupsReducer,
});

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getAllGroups: () => dispatch(groupsActions.getAllGroups()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Employees));
